import { vuexfireMutations, firestoreAction } from "vuexfire";
import { sparePartsCollection, db } from "@/plugins/db.js";
export default {
  namespaced: true,

  // setup the reactive todos property
  state: {
    sparePartsList: [],
    sparePartProfile: {}
  },

  mutations: {
    ...vuexfireMutations
  },
  actions: {
    callSpareParts: context => {
      context.dispatch("bindSpareParts");
    },
    bindSpareParts: firestoreAction((context, id) => {
      return context.bindFirestoreRef(
        "sparePartsList",
        sparePartsCollection
          .where("equipmentProfile", "==", db.doc(`equipments/${id}`))
          .where("disabled", "==", false)
          .orderBy("dateCreated", "desc")
      );
    }),
    bindASparePart: firestoreAction((context, id) => {
      return context.bindFirestoreRef(
        "sparePartProfile",
        sparePartsCollection.doc(id)
      );
    })
  },
  getters: {}
};
